import React, { useContext, useState, useEffect } from "react";
import { TemplateContext } from "../../layout";
import ProductSelectorButton from "../ProductSelectorButton.jsx";

const VariantOptionRadio = ({ handleClick, label, type, sku, size, color }) => {
  const [templateContext, setTemplateContext, variantsContext, setVariantsContext] = useContext(TemplateContext);
  const [active, setActive] = useState();

  useEffect(() => {
    if (variantsContext?.variants) {
      setActive(
        type == "color" ? variantsContext?.variants[0]?.color == sku : variantsContext?.variants[0]?.size == sku
      );
    }
  }, [variantsContext?.variants]);

  return (
    <li
      className={`custom-radio--item ${active && "custom-radio--item--active"} custom-radio--item--${size}`}
      onClick={() => {
        handleClick(sku, label);
      }}
    >
      <div className="custom-radio--item__wrapper">
        <ProductSelectorButton />
        {type === "color" && (
          <div className="custom-select__colorIndicator" style={{ background: color ? color : "#000" }}></div>
        )}
        {label && <span>{label}</span>}
      </div>
    </li>
  );
};

export default VariantOptionRadio;
